import moment from 'moment';

class EventUtils {
    constructor(data) {

        for (let obj in data){
            this[obj] = data[obj];
        }
    }
    set(obj, value){
        this[obj] = value;
    }

    getStatus = ()=>{
        const now = moment();

        let status = { code: 0, value: "INCOMPLETE" };

        if (this.facebook !== undefined) {
            status = { code: 1, value: "NOT_STARTED" };
            if (this.startDate.isBefore(now) && now.isBefore(this.endDate)) {
                status = { code: 2, value: "IN_PROGRESS" };
            } else {
                if (this.endDate.isBefore(now)) {
                    status = { code: 3, value: "FINISHED" };
                }
            }

        }

        return status;
    }
}


export default EventUtils;